export default {
    server_response: (attribute: string) => `${attribute}`,
    attach_csv_first: () => 'Please attach csv first',
    please_attach_first: () => 'Please attach file',
    please_create_facility_before_uploading_photos: () => 'Please create facility before uploading photos',
    from_and_till_times_are_required: () => 'From and Till times are required',
    please_select_at_least_one_day: () => 'Please select at least one day',
    please_select_at_least_one_project: () => 'Please select at least one project',
    event_start_time_must_be_before_event_end_time: () => 'Event start time must be before event end time',
    offer_has_been_closed_at: (attribute: string) => `This offer has been closed at ${attribute}`,
    offer_has_been_archived_at: (attribute: string) => `This offer has been archived at ${attribute}`,
    at_least_one_applicant_should_be_selected: () => 'At least one applicant should be selected',
    deadline_date_is_required: () => 'Deadline date is required',
    deadline_and_presentation_dates_are_required: () => 'Deadline and presentation dates are required',
    deadline_date_should_be_later_then_today: () => 'Deadline date should be later then today',
    deadline_and_presentation_dates_should_be_later_then_today: () => 'Deadline and presentation dates should be later then today',
    tag_already_exists_in_interests_list: () => 'Tag already exists in interests list',
    tag_already_exists_in_educational_list: () => 'Tag already exists in educational list',
    tag_has_been_added_please_submit_form_to_save_changes: () => 'Tag has been added. Please submit form to save changes',
    please_fill_message_field: () => 'Please fill message field',
    please_select_the_category: () => 'Please select the category',
    no_previous_tenancy_period_exists: () => 'No previous tenancy period exists',
    please_select_at_least_one_unit: () => 'Please select at least one unit',
    please_select_integration_first: () => 'Please select an integration first',
    content_field_is_required: () => 'The content field is required',
    please_select_project_first: () => 'Please select project first',
    grouping_has_been_created: () => 'Grouping has been created',
    grouping_has_been_updated: () => 'Grouping has been updated',
    grouping_has_been_deleted: () => 'Grouping has been deleted',
    file_has_been_successfully_uploaded: () => 'File has been successfully uploaded',
    error_occurred_on_file_upload: () => 'Error occurred on file upload',
    text_has_been_updated: () => 'Text has been updated',
    language_has_been_added: () => 'Language has been added',
    language_key_has_been_added: () => 'Language key has been added',
    csv_has_been_imported: () => 'CSV has been imported',
    unit_is_already_occupied: () => 'Unit is already occupied',
    tenant_has_been_assigned: () => 'Tenant has been assigned',
    presentation_has_been_created: () => 'Presentation has been created',
    presentation_has_been_updated: () => 'Presentation has been updated',
    presentation_has_been_changed_as_deadline_reached: () => 'Presentation has been changed as deadline reached',
    offer_has_been_re_open: () => 'Offer has been re-open',
    offer_has_been_completed: () => 'Offer has been completed',
    user_has_already_been_assigned_to_another_unit: () => 'User has already been assigned to another unit. Please reopen the offer',
    unit_is_already_occupied_please_reopen_and_close_the_offer: () => 'Unit is already occupied. Please reopen and close the offer',
    offer_has_been_declined: () => 'Offer has already been declined',
    offer_has_been_closed: () => 'Offer has been closed',
    unit_dates_has_been_updated_successfully: () => 'Unit dates has been updated successfully',
    facility_has_active_bookings_please_cancel_them_before_delete: () => 'Facility has active bookings. Please cancel them before delete',
    facility_has_been_deleted: () => 'Facility has been deleted',
    booking_has_been_canceled: () => 'Booking has been canceled',
    facility_has_been_created: () => 'Facility has been created',
    facility_has_been_updated: () => 'Facility has been updated',
    facility_photos_has_been_updated: () => 'Facility photos has been updated',
    facility_photos_order_has_been_updated: () => 'Facility photos order has been updated',
    facility_availability_has_been_updated: () => 'Facility availability has been updated',
    tag_has_been_created_and_added_to_your_interests: () => 'Tag has been created added to your interests',
    tag_has_been_created_and_added_to_your_educational_institution: () => 'Tag has been created and added to your educational institution',
    application_has_been_accepted: () => 'Application has been accepted',
    application_has_been_rejected: () => 'Application has been rejected',
    application_status_toggle: (attribute: string) => `Application is ${attribute} now`,
    expiration_emails_has_been_sent: () => 'Expiration emails has been sent',
    application_has_been_deleted: () => 'Application has been deleted',
    application_data_has_been_updated: () => 'Application data has been updated',
    profiling_data_has_been_updated: () => 'Profiling data has been updated',
    personal_data_has_been_updated: () => 'Personal data has been updated',
    profile_image_has_been_updated_successfully: () => 'Profile image has been updated successfully',
    reset_password_has_been_sent: () => 'Reset password has been sent',
    profile_date_has_been_updated_successfully: () => 'Profile data has been updated successfully',
    password_has_been_changed_successfully: () => 'Password has been changed successfully',
    ticket_has_been_added: () => 'Ticket has been added',
    ticket_has_been_updated: () => 'Ticket has been updated',
    inquiry_has_been_created: () => 'Inquiry has been created',
    inquiry_has_been_updated: () => 'Inquiry has been updated',
    inquiry_has_been_deleted: () => 'Inquiry has been deleted',
    inquiry_cannot_be_deleted_as_it_has_assigned_tickets: () => 'Inquiry can\'t be deleted, as it has assigned tickets',
    category_has_been_created: () => 'Category has been created',
    category_has_been_updated: () => 'Category has been updated',
    category_has_been_deleted: () => 'Category has been deleted',
    category_cannot_be_deleted_as_it_has_assigned_inquiries: () => 'Category can\'t be deleted, as it has assigned inquiries',
    application_has_been_updated: () => 'Application has been updated',
    max_bookings: (amount: string) => `Max ${amount} allowed`,
    max_bookable_slots_cannot_be_zero: () => `Max bookable slots cannot be 0`,
    select_project_first: () => 'Please, select the project first',
    select_project_unit_first: () => 'Please, select project and unit first',
    select_project_category_first: () => 'Please, select project and category first',
    select_project_type_first: () => 'Please, select project and type first',
    upcoming_tenant_has_been_reverted: () => 'Upcoming tenant has been reverted',
    upcoming_tenant_move_in_has_been_canceled: () => 'The upcoming tenant move in has been canceled',

    // Abuse
    conversation_reported: () => 'The conversation has been reported',
    user_blocked: () => 'The user has been blocked',
    conversation_hidden: () => 'The conversation is now hidden',
};
